import { PAYMENTS_SECTIONS_ROUTES } from '@/models/app-internal/permissions.model';
import { RouteComponent, RouteRecordRaw } from 'vue-router';

export const cashierSettingsRoutes: RouteRecordRaw[] = [
  {
    name: PAYMENTS_SECTIONS_ROUTES.CASHIER_SETTINGS,
    path: `/${PAYMENTS_SECTIONS_ROUTES.CASHIER_SETTINGS}`,
    component: async(): Promise<RouteComponent> =>
      await import('@/layouts/cashier-settings-page/cashier-settings-page.vue'),
  },
];
